import React from 'react'
import { transformAddress } from 'utils'
import Jazzicon from 'react-jazzicon'
import { jsNumberForAddress } from 'react-jazzicon'
import AccountToolTip from './tooltip'
import {
  StyledAccountDetailsContainer,
  StyledAccountDetailsLeftContainer,
  StyledAccountAddressText,
} from '../styled'
import { useAccount } from 'wagmi'

/**
 * React component for showing the account details section.
 * @returns AccountDetails
 */
const AccountDetails: React.FC = () => {
  // Get account and network details from framework
  const { isConnected, address, chain } = useAccount()

  // handle undefined cases
  const currentNetwork = chain?.id || 0
  const addressOrNull = isConnected ? address || '0x0' : '0x0'

  return (
    <StyledAccountDetailsContainer>
      <StyledAccountDetailsLeftContainer>
        <Jazzicon diameter={24} seed={jsNumberForAddress(addressOrNull)} />
        <StyledAccountAddressText title={address}>
          {transformAddress(addressOrNull, 4)}
        </StyledAccountAddressText>
      </StyledAccountDetailsLeftContainer>
      <AccountToolTip account={addressOrNull} network={currentNetwork} />
    </StyledAccountDetailsContainer>
  )
}

export default AccountDetails
